import React, { useContext, useEffect, useState } from "react";
import arePropsEqual from "react-fast-compare";
import { useSelector } from "react-redux";
import { Checkbox } from "@mui/material";

//context
import { TrackersContext } from "../../../../TrackersContext";

//selectors
import {
	selectArchivedListData,
	selectListData,
} from "../../../../../../../../../store/admin/affiliateTrackers/selectors";

interface ISelectAllTrackersProps {
	archived?: boolean;
}

const SelectAllTrackers = ({ archived = false }: ISelectAllTrackersProps) => {
	const context = useContext(TrackersContext);
	const actualData = useSelector(selectListData);
	const archivedData = useSelector(selectArchivedListData);

	const data = archived ? archivedData : actualData;

	const [checked, setChecked] = useState<boolean>(false);

	useEffect(() => {
		if (!context.selectedTrackers.length) {
			setChecked(false);
		}
	}, [context.selectedTrackers]);

	useEffect(() => {
		if (!!data) {
			const idsA = new Set(context.selectedTrackers.map(({ id }) => id));
			const allMatched = data.list.every(({ id }: any) => idsA.has(id));
			if (!allMatched) {
				setChecked(false)
			}
			if (allMatched) {
				setChecked(true)
			}
		}

	}, [data, context.selectedTrackers])

	const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		setChecked(event.target.checked);
		if (!!data && event.target.checked) {
			context.setSelectedTrackers((prevState: any) => {
				const toAdd = data.list.filter((item: any) =>
					!prevState.some((existing: any) => existing.id === item.id)
				);
				return [...prevState, ...toAdd];
			});
		} else {
			context.setSelectedTrackers((prevState: any) => {
				if (!data) return prevState;
				const incomingIds = new Set(data.list.map((item: any) => item.id));
				const filteredList = prevState.filter((item: any) => !incomingIds.has(item.id));
				return filteredList;
			})
		}
	}

	return (
		<>
			<Checkbox
				size="small"
				sx={{ padding: '4px' }}
				checked={checked}
				onChange={handleChange}
				inputProps={{ 'aria-label': 'controlled' }}
			/>
		</>
	);
};

export default React.memo(SelectAllTrackers, arePropsEqual);
